/**
 * @generated SignedSource<<6148e1e6b14e0245207c23387764ebea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleLanding_browseContentModule$data = {
  readonly bannerImage: string | null;
  readonly bannerVideo: string | null;
  readonly eyeBrowText: string | null;
  readonly isMuxVideo: boolean | null;
  readonly landingBackgroundTintColor: string | null;
  readonly landingTextColor: string | null;
  readonly landingTiles: ReadonlyArray<{
    readonly imageUrl: string | null;
    readonly linkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly localizedLinkDataList: ReadonlyArray<{
      readonly currency: string | null;
      readonly linkData: {
        readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
      };
    } | null> | null;
    readonly title: string | null;
  } | null> | null;
  readonly landingTilesBackgroundColor: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "SbRespContentModuleLanding_browseContentModule";
};
export type SbRespContentModuleLanding_browseContentModule$key = {
  readonly " $data"?: SbRespContentModuleLanding_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleLanding_browseContentModule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleLanding_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bannerVideo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMuxVideo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bannerImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eyeBrowText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingBackgroundTintColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingTilesBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingTextColor",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BrowseContentModuleLandingTile",
      "kind": "LinkedField",
      "name": "landingTiles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalizedLinkData",
          "kind": "LinkedField",
          "name": "localizedLinkDataList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentModuleLanding",
  "abstractKey": null
};
})();

(node as any).hash = "121ce104c6eaec1f0fc2e581a8bc2046";

export default node;
